import { useEffect, useRef } from 'react';

const steps = [
  {
    icon: 'ri-user-unfollow-line',
    title: 'Desistência ou Exclusão',
    desc: 'Muitas pessoas desistem ou são excluídas do consórcio sem saber que têm direitos.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Direito Garantido por Lei',
    desc: 'A legislação brasileira garante a restituição de valores pagos em casos de saída do grupo.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Recupere Até 76%',
    desc: 'Com ação judicial, é possível recuperar até 76% do total pago, com correção monetária.',
  },
];

export default function Explicativa() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.animate-card').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 150);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="explicativa" className="py-20 md:py-28 bg-green-50" ref={sectionRef}>
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <div className="w-16 h-16 flex items-center justify-center bg-green-500 rounded-full mx-auto mb-5">
            <i className="ri-information-line text-white text-2xl"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
            Você sabia que pode recuperar<br className="hidden md:block" /> seu dinheiro do consórcio?
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto leading-relaxed">
            Muitas pessoas desistem ou são excluídas de consórcios e{' '}
            <strong className="text-gray-800">não sabem que podem recuperar parte significativa</strong>{' '}
            dos valores pagos através de ação judicial. Esse direito está previsto em lei e pode ser
            exercido mesmo anos após a saída do grupo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {steps.map((step) => (
            <div
              key={step.title}
              className="animate-card bg-white rounded-2xl p-7 border border-green-100 transition-all duration-300 hover:border-green-300"
              style={{ opacity: 0, transform: 'translateY(24px)', transition: 'opacity 0.5s ease, transform 0.5s ease' }}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-xl mb-4">
                <i className={`${step.icon} text-green-600 text-xl`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-lg mb-2">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-center">
          <div className="inline-flex items-center gap-4 bg-white border-2 border-dashed border-green-400 rounded-2xl px-8 py-5">
            <div className="w-10 h-10 flex items-center justify-center bg-green-500 rounded-full flex-shrink-0">
              <i className="ri-arrow-up-line text-white text-lg"></i>
            </div>
            <div>
              <p className="text-sm text-gray-500 font-medium">Valor estimado de recuperação</p>
              <p className="text-2xl font-extrabold text-green-600">Recupere até 76% do valor pago</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
